/**
 * @desc 异常关闭
 */
const URL = "/rantion-tms";
import http, { updateResponse } from "@/http";
export type Response = defs.tms.Response;
export function request(sourceNo: string | number, options?: any): Promise<Response> {
  return updateResponse(
    http(URL + `/customsClearance/abnormalClose/${sourceNo}`, {
      method: "POST",

      ...options,
    }),
  );
}
